var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"v3-img",class:{ gray: _vm.gray, grayscale: _vm.grayscale, outline: _vm.outline },attrs:{"draggable":"false","src":_vm.src}})}
var staticRenderFns = []

export { render, staticRenderFns }